import { IconButton, InputAdornment } from "@mui/material"
import { SearchIcon } from "@uy3/web-components"

type ActionSubmitSearchProps = {
    typeButton?: 'submit' | 'button'; 
    onClick?: () => void;
}

export const ActionSubmitSearch = ({ typeButton = 'submit', onClick }:ActionSubmitSearchProps) => {
    let colorIcon = "#666666";
    return (
        <InputAdornment position="end">
            <IconButton type={typeButton} onClick={typeButton === 'button' ? onClick : undefined}>
                <SearchIcon
                    sx={{ width: 25, height: 25 }}
                    htmlColor={colorIcon}
                />
            </IconButton>
        </InputAdornment>
    )
}